import { cn } from '../cn'

export function initials(name: string): string {
  const parts = name
    .replace(/@.*$/, '')
    .split(/[\s._-]+/)
    .filter(Boolean)
  const first = parts[0]?.[0] ?? '?'
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
  return `${first}${last}`.toUpperCase()
}

export interface AvatarProps {
  name: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES = {
  sm: 'size-7 text-xs',
  md: 'size-9 text-[13px]',
  lg: 'size-12 text-base',
} as const

/** Initials avatar (the prototype's relationship-team avatar). Decorative: show the name nearby. */
export function Avatar({ name, size = 'md', className }: AvatarProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-[#e1ebd9] font-semibold text-[#4d6a46] ring-1 ring-[#cfdcc5]',
        SIZES[size],
        className,
      )}
    >
      {initials(name)}
    </span>
  )
}
